import { LayoutComponent } from '../layout/layout.component';


export const routes = [

    
    // Not found
    { path: '', redirectTo: './home/socialboard', pathMatch:'full'},
    
    {
        path: '',
        component: LayoutComponent,
        children: [
            { path: '', loadChildren: './home/home.module#HomeModule' },
            { path: 'home', loadChildren: './home/home.module#HomeModule' }
        ]
    },
];



// WEBPACK FOOTER //
// C:/Projects/Isagenix/GitHub/Mobile.IsaLifeAzure/apps/qualia-platform-admin-web/src/app/routes/routes.ts